// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { documentTemplateId } from './DocumentTemplate';
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodSensoryConfigId = (z.number());
export const foodSensoryConfig = z.object({
    id: foodSensoryConfigId,
    consent_template_id: documentTemplateId.nullable(),
    updated_at: z.date().nullable(),
    updated_by: operatorId.nullable(),
    intake_valid_days: z.number().nullable(),
    exposure_limit_g: z.string().nullable(),
});
export const foodSensoryConfigInitializer = z.object({
    id: foodSensoryConfigId.optional(),
    consent_template_id: documentTemplateId.optional().nullable(),
    updated_at: z.date().optional().nullable(),
    updated_by: operatorId.optional().nullable(),
    intake_valid_days: z.number().optional().nullable(),
    exposure_limit_g: z.string().optional().nullable(),
});
export const foodSensoryConfigMutator = z.object({
    id: foodSensoryConfigId.optional(),
    consent_template_id: documentTemplateId.optional().nullable(),
    updated_at: z.date().optional().nullable(),
    updated_by: operatorId.optional().nullable(),
    intake_valid_days: z.number().optional().nullable(),
    exposure_limit_g: z.string().optional().nullable(),
});
//# sourceMappingURL=FoodSensoryConfig.js.map